import { Navigate, useNavigate } from 'react-router-dom';
import { getModuleEntryBySlug } from '@/config/moduleEntries';
import { MODULE_HUB_PATH } from '@/constants/authRoutes';
import { LoginForm } from '@/pages/auth/LoginForm';
import { clearPlatformOnboardingRequired } from '@/modules/onboarding/onboardingState';

interface ModuleLoginPageProps {
  slug: string;
}

export function ModuleLoginPage({ slug }: ModuleLoginPageProps) {
  const navigate = useNavigate();
  const moduleEntry = getModuleEntryBySlug(slug);

  if (!moduleEntry) {
    return <Navigate to={MODULE_HUB_PATH} replace />;
  }

  return (
    <LoginForm
      moduleEntry={moduleEntry}
      showRegisterLink
      showAdminHint
      onLoginSuccess={() => {
        clearPlatformOnboardingRequired();
        navigate(moduleEntry.homePath, { replace: true });
      }}
    />
  );
}
